var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEyeClosed = function SvgIconEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9612 13.2504C15.8471 13.2504 19.2405 11.1398 21.0568 8L21.9224 8.50073C19.9347 11.9368 16.2185 14.2504 11.9612 14.2504C7.70395 14.2504 3.98765 11.9368 2 8.50073L2.86561 8C4.68186 11.1398 8.07535 13.2504 11.9612 13.2504Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 16.0981L14 13.5L14.866 13L16.366 15.5981L15.5 16.0981Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2004 13.7248L19.0791 11.6035L19.7862 10.8964L21.9075 13.0177L21.2004 13.7248Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86621 16.0981L10.3662 13.5L9.50019 13L8.00019 15.5981L8.86621 16.0981Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78591 13.7248L4.90723 11.6035L4.20012 10.8964L2.0788 13.0177L2.78591 13.7248Z"
  })));
};
export default SvgIconEyeClosed;